import { render } from "./PurchasePaymentCreateComponent.vue?vue&type=template&id=4ca68c62"
import script from "./PurchasePaymentCreateComponent.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentCreateComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/purchase/PurchasePaymentCreateComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ca68c62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ca68c62', __exports__)) {
    api.reload('4ca68c62', __exports__)
  }
  
  module.hot.accept("./PurchasePaymentCreateComponent.vue?vue&type=template&id=4ca68c62", () => {
    api.rerender('4ca68c62', render)
  })

}


export default __exports__